import { Navigate } from 'react-router-dom';
import { isLoggedIn } from '../api/client';

export default function ProtectedRoute({ children }) {
  return isLoggedIn() ? children : <Navigate to="/admin/login" replace />;
}
